import React, { Fragment } from "react";
import { Col, Table, Form, Row } from "react-bootstrap";

interface FinancialViewProps
{
    data: Financial;
}

export default class FinancialView extends React.Component<FinancialViewProps>
{
    render(): React.ReactNode 
    {
        return <Form>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Financial Aid Recipient
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.financialAidRecipient ? this.props.data.financialAidRecipient : "-"}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    RA/TA Appointments
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.rataAppointments ? this.props.data.rataAppointments : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Work Study Hours
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        {
                            (this.props.data.workStudyHours)
                                ?
                                <Fragment>
                                    <b>{this.props.data.workStudyHours.averageHours}</b> <i style={{ opacity: "0.7" }}>(average weekly hours for {this.props.data.workStudyHours.termCode})</i>
                                </Fragment>
                                :
                                <b> - </b>
                        }
                    </Form.Control>
                </Col>
            </Form.Group>
        </Form>;
    }
}